/* SENSEZ · GROWTH Q4 · Ficha de producto. Sin dependencias; usa el formulario original del tema.
   1) «Elige tu talla»: el tema preselecciona la primera talla (S), pero el 99 % de lo vendido es 3XL–6XL. Si el
      cliente no eligió talla (y no llegó con ?variant=), no se agrega al carrito ni se va a «Comprar ahora»:
      se le pide elegir. No cambia precios, variantes ni el carrito.
   2) Barra fija de compra en móvil siempre que el botón original no está en pantalla (antes o después de él). */
(() => {
  const bar = document.querySelector('[data-sz-satc]');
  const sid = bar ? bar.dataset.section : null;
  // El tema vuelve a dibujar el botón al cambiar de variante: siempre se lee el botón vigente.
  const boton = () => (sid && document.getElementById(`ProductSubmitButton-${sid}`)) || document.querySelector('product-form button[name="add"]');
  const main = boton();
  if (!main) return;
  const picker = (sid && document.querySelector(`variant-selects[data-section="${sid}"]`)) || document.querySelector('variant-selects');

  // ---------- 1) Elegir talla explícitamente ----------
  const grupo = picker && [...picker.querySelectorAll('fieldset')].find((f) => /talla/i.test(f.querySelector('legend')?.textContent || ''));
  const radios = grupo ? [...grupo.querySelectorAll('input[type="radio"]')] : [];
  let elegida = !grupo || radios.length < 2 || new URLSearchParams(location.search).has('variant');
  let aviso = null;
  if (!elegida) {
    radios.forEach((r) => { r.checked = false; });
    aviso = document.createElement('p');
    aviso.className = 'sz-elige-talla';
    aviso.setAttribute('role', 'status');
    aviso.textContent = 'Elige tu talla para agregar al carrito.';
    grupo.appendChild(aviso);
    grupo.addEventListener('change', () => { elegida = true; aviso.remove(); }, { once: true });
  }
  const pedirTalla = () => {
    if (aviso) { aviso.classList.add('is-alerta'); }
    grupo.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  document.addEventListener('submit', (e) => {
    if (!elegida && e.target.closest && e.target.closest('product-form')) { e.preventDefault(); e.stopImmediatePropagation(); pedirTalla(); }
  }, true);
  document.addEventListener('click', (e) => {
    if (elegida) return;
    if (e.target.closest('.shopify-payment-button') || e.target.closest(`#ProductSubmitButton-${sid}`)) {
      e.preventDefault(); e.stopImmediatePropagation(); pedirTalla();
    }
  }, true);

  // ---------- 2) Barra fija (móvil) ----------
  if (!bar) return;
  // Un contenedor de la ficha tiene transform/sticky: se mueve la barra al body para que quede fija abajo.
  document.body.appendChild(bar);
  const btn = bar.querySelector('[data-sz-satc-btn]');
  const talla = bar.querySelector('[data-sz-satc-size]');
  const precio = bar.querySelector('[data-sz-satc-price]');
  function sync() {
    // Dawn vuelve a dibujar el selector al cambiar de variante: se busca de nuevo el grupo de tallas.
    const g = picker && [...document.querySelectorAll('variant-selects fieldset')].find((f) => /talla/i.test(f.querySelector('legend')?.textContent || ''));
    const sel = g && g.querySelector('input:checked');
    if (talla) talla.textContent = elegida && sel ? sel.value : 'por elegir';
    const p = document.querySelector(`#price-${sid} .price-item--sale, #price-${sid} .price-item--regular`);
    if (p && precio && p.textContent.trim()) precio.textContent = p.textContent.trim();
    const b = boton();
    const agotado = !b || b.disabled || b.getAttribute('aria-disabled') === 'true';
    btn.textContent = !elegida ? 'Elegir talla' : agotado ? 'Elegir otra talla' : 'Agregar al carrito';
  }
  const mostrar = (on) => {
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('sz-satc-on', on);
  };
  // Se observa el contenedor de botones (no se vuelve a dibujar al cambiar de variante). La barra se ve siempre que el
  // botón original no esté en pantalla: antes de llegar a él (móvil: la 1.ª pantalla es la galería) y después de pasarlo.
  new IntersectionObserver(([e]) => mostrar(!e.isIntersecting)).observe(main.closest('.product-form__buttons') || main);
  btn.addEventListener('click', () => {
    sync();
    if (!elegida) { pedirTalla(); return; }
    const b = boton();
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') { (document.querySelector('variant-selects') || b).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    b.click();
  });
  // El tema deshabilita el botón mientras carga la variante nueva: se sincroniza de nuevo al terminar.
  document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('variant-selects')) [150, 900, 2000].forEach((ms) => setTimeout(sync, ms)); });
  sync();
})();
